import { faArrowRight } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect } from 'react'
import { useParams } from 'react-router'

import { type OnboardingPage } from '../routes'
import { PricingASDCoversSection } from '../components/PricingASDCoversSection'
import { PricingASDProPackageSection } from '../components/PricingASDProPackageSection'
import { OnboardingTitle } from '../components/OnboardingTitle'
import { OnboardingNextButton } from '../components/OnboardingNextButton'
import { useOnboardingWorkflow } from '../workflow'
import { PricingCardAssistanceDomestique } from '../components/PricingCardAssistanceDomestique'
import { track } from '../../utils/analytics'
import { PricingASDProCoversOptions } from '../components/PricingASDProCoversOptions'
import { useQuotation } from '../context'

import { Card, CardContent } from '@olino/design-system'
import { PricingASDProGuaranteeAmountSlider } from '../components/PricingASDProGuaranteeAmountSlider'
import { PricingCard } from '../components/PricingCard'
import { FormattedPrice } from '../components/FormattedPrice'

const Main = () => {
  const { id } = useParams()
  const { proceed } = useOnboardingWorkflow()
  const { quotation } = useQuotation()

  const onProceed = () => {
    track({
      event: 'submitted_pricing_page',
      quotation_id: id,
    })

    proceed()
  }

  useEffect(() => {
    track({
      event: 'visited_pricing_page',
      quotation_id: id,
    })
  }, [id])

  return (
    <>
      <OnboardingTitle.H1>Votre devis pour votre Assistance Dépannage Express</OnboardingTitle.H1>

      <div className="space-y-14">
        <div className="block lg:hidden">
          <PricingCard>
            <PricingASDCoversSection />
          </PricingCard>
        </div>

        <Card>
          <CardContent className="space-y-8">
            <div className="flex justify-between">
              <div className="flex flex-col gap-1">
                <OnboardingTitle.H2Pricing>Protections essentielles</OnboardingTitle.H2Pricing>
                <span className="text-xs md:text-sm">
                  Avec l'Assistance Dépannage Express de notre partenaire AXA, bénéficiez d'une
                  prise en charge 24h/24 et 7j/7 en cas de panne
                </span>
              </div>

              <div className="space-y-3">
                <FormattedPrice
                  size="sm"
                  originalAmount={quotation.premium?.assistanceDomestiqueProfessionnel?.base}
                  hideLoader
                />
              </div>
            </div>

            <PricingASDProGuaranteeAmountSlider />

            <div className="space-y-3">
              <PricingASDProCoversOptions displayOnlyCover />
            </div>
          </CardContent>
        </Card>

        <PricingASDProPackageSection />

        <div className="flex flex-col gap-8">
          <div className="flex justify-end">
            <OnboardingNextButton onClick={() => onProceed()}>
              Souscrire
              <FontAwesomeIcon icon={faArrowRight} />
            </OnboardingNextButton>
          </div>
        </div>
      </div>
    </>
  )
}

const Tips = () => {
  return (
    <div className="hidden lg:block">
      <PricingCardAssistanceDomestique>
        <PricingASDCoversSection />
      </PricingCardAssistanceDomestique>
    </div>
  )
}

export default {
  main: <Main />,
  tips: <Tips />,
} satisfies OnboardingPage
